import { ListPageSkeleton } from '@practium/ui';

export const RecommendationsPageSkeleton = () => (
	<ListPageSkeleton
		tabsCount={3}
		sidebarWidth="28rem"
		sidebarW1500="22rem"
		sidebarW1300="19rem"
		sidebarW1200="17rem"
	/>
);
